const numerals = {
  zh_HK: ['零', '壹', '貳', '叁', '肆', '伍', '陸', '柒', '捌', '玖'],
  zh_CN: ['零', '壹', '贰', '叁', '肆', '伍', '陸', '柒', '捌', '玖']
};

const units = {
  zh_HK: ['', '拾', '佰', '仟'],
  zh_CN: ['', '拾', '佰', '仟']
};

const bigUnits = {
  zh_HK: ['', '萬', '億', '兆'],
  zh_CN: ['', '万', '亿', '兆']
};

function numberToChineseWords(num, lang) {
  if (num === 0) return numerals[lang][0];
  
  let str = num.toString();
  let result = '';
  let sections = [];
  
  // 每四位一組
  while (str.length > 0) {
    sections.push(str.slice(Math.max(0, str.length - 4)));
    str = str.slice(0, Math.max(0, str.length - 4));
  }
  
  for (let i = 0; i < sections.length; i++) {
    let sectionNum = parseInt(sections[i]);
    if (sectionNum === 0) {
      if (i < sections.length - 1 && parseInt(sections[i+1]) > 0) {
        result = numerals[lang][0] + result;
      }
      continue;
    }
    
    let sectionStr = sections[i].padStart(4, '0');
    let sectionResult = '';
    let zero = false;
    
    for (let j = 0; j < 4; j++) {
      let digit = parseInt(sectionStr[j]);
      if (digit === 0) {
        zero = true;
      } else {
        if (zero) {
          sectionResult += numerals[lang][0];
          zero = false;
        }
        sectionResult += numerals[lang][digit] + units[lang][3 - j];
      }
    }
    
    result = sectionResult + bigUnits[lang][i] + result;
  }
  
  // 處理開頭是「拾」的情況（非必須，但支票通常寫「壹拾」）
  return result.replace(/^拾/, '壹拾');
}

export const convertToChinese = (num, lang = 'zh_HK') => {
  if (isNaN(num)) return '等待轉換...';
  
  const isNegative = num < 0;
  const absNum = Math.abs(num);
  const integerPart = Math.floor(absNum);
  const decimalPart = Math.round((absNum - integerPart) * 100);
  
  let result = isNegative ? '負' : '';
  
  // 整數部分
  if (integerPart === 0) {
    result += numerals[lang][0];
  } else {
    result += numberToChineseWords(integerPart, lang);
  }
  
  const currencyUnit = lang === 'zh_HK' ? '圓' : '元';
  const zeroUnit = lang === 'zh_HK' ? '正' : '整';
  
  if (decimalPart === 0) {
    result += currencyUnit + zeroUnit;
  } else {
    result += currencyUnit;
    const jiao = Math.floor(decimalPart / 10);
    const fen = decimalPart % 10;
    
    if (jiao > 0) {
      result += numerals[lang][jiao] + '角';
    } else if (integerPart > 0) {
      result += numerals[lang][0];
    }
    
    if (fen > 0) {
      result += numerals[lang][fen] + '分';
    } else {
      result += zeroUnit;
    }
  }
  
  return result;
};